// imports
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import ExcipientTypeSelect from 'components/common/simpleSelectors/ExcipientType';
// interfaces
import { ExcipientTypeSelectorProps } from 'interfaces';

const ExcipientTypeSelector: FC<ExcipientTypeSelectorProps> = ({ name, title, handleChange, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <ExcipientTypeSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ExcipientTypeSelector;
